/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { Button, FontAwesomeIcon, Heading } from "components";
import { useTranslation } from "react-i18next";

const TermsOfUseAndPolicyModal = ({ closeModal, type }) => {
  const { t, i18n } = useTranslation();
  const isAr = i18n.language === "ar";

  const CONTENT = t(type === "policy" ? "legal.policy" : "legal.terms", {
    returnObjects: true,
  });

  if (!CONTENT || typeof CONTENT === "string") {
    return null;
  }

  return (
    <div
      className="w-full h-screen sm:h-auto max-w-3xl p-8 -bg--theme-colors-surface-neutral-level02"
      dir={isAr ? "rtl" : "ltr"}
    >
      <div className="flex items-center mb-6 justify-between gap-x-2 sm:gap-x-0">
        <Heading as="h3" className="-text--theme-colors-text-title text-4xl">
          {CONTENT.title}
        </Heading>
        <div>
          <Button variant="ghost" size="md" onClick={closeModal}>
            <div className="p-1">
              <FontAwesomeIcon name="fa-xmark" size="2xl" />
            </div>
          </Button>
        </div>
      </div>
      <div className="overflow-y-scroll mt-2 h-full sm:h-72 -text--theme-colors-text-body">
        {Object.values(CONTENT.sections).map((section, index) => (
          <section key={index}>
            <h5 className="text-xl font-bold -text--theme-colors-text-title-brand">
              {section.title}
            </h5>
            {section.description && (
              <div className="text-sm sm:pe-8 mt-4 mb-6">
                {Array.isArray(section.description) ? (
                  section.description.map((item, idx) => {
                    if (typeof item === "object" && item.link) {
                      return (
                        <a
                          key={idx}
                          href={item.link.href}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="underline"
                        >
                          {item.link.text}
                        </a>
                      );
                    } else {
                      return <span key={idx}>{item}</span>;
                    }
                  })
                ) : (
                  <p>{section.description}</p>
                )}
              </div>
            )}
            {section.articles &&
              section.articles.map((article, idx) => (
                <article key={idx}>
                  {article.title && (
                    <h6 className="text-sm font-medium mt-2">
                      {article.title}
                    </h6>
                  )}
                  {Array.isArray(article.description) ? (
                    <div className="text-sm sm:pe-8 mt-4 mb-6">
                      {article.description.map((item, idx) => {
                        if (typeof item === "object" && item.link) {
                          return (
                            <a
                              key={idx}
                              href={item.link.href}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="underline"
                            >
                              {item.link.text}
                            </a>
                          );
                        } else {
                          return <span key={idx}>{item}</span>;
                        }
                      })}
                    </div>
                  ) : (
                    <div className="text-sm sm:pe-8 mt-4 mb-6">
                      <p>{article.description}</p>
                    </div>
                  )}
                </article>
              ))}
          </section>
        ))}
      </div>
    </div>
  );
};
export default TermsOfUseAndPolicyModal;
